import styled from 'styled-components';
import backgroundImage from './../../assets/background-header.webp';
interface ResponsiveProps {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}


export const Layout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MainWrapper = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  background-image: url(${backgroundImage});
  background-size: 100% auto;
  background-repeat: repeat-y;
  background-position: top center;
  min-height: 100vh;
  max-width: 100vw;
  padding: 5px;
`;

export const MainContent = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  width: 100%;
  max-width: 1200px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

export const Ads = styled.div`
  width: 300px;
  min-height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fbf9ec;
  border-radius: 15px;
  padding: 16px;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;